export default "__VITE_ASSET__7431105e__"